import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';

interface BreakingChangeDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** The deliberate extra step before a change that can unlink frames already built on a format. */
export function BreakingChangeDialog({ open, onCancel, onConfirm }: BreakingChangeDialogProps) {
  const { t } = useTranslation('admin');
  return (
    <AlertDialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('admin.adFormats.breaking.title')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('admin.adFormats.breaking.description')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('admin.adFormats.cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {t('admin.adFormats.breaking.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
